import { StatusBar } from "@common/systemBars/StatusBar"
import React from "react"
import { ParentShellHeader } from "../../../ports/primary/ui/screens/parent/ParentShellHeader"
import { useParentStatusBar } from "../../../ports/primary/ui/hooks/useParentStatusBar"

/**
 * Le header de l'espace parent : celui du design system.
 *
 * `ParentShellHeader` monte la feuille « Changer de profil » du design system ; ce header ne fait
 * que lui descendre ce que la coquille sait (les comptes, la bascule en cours, les gestes).
 */
export const ParentTabHeader = ({
    familyAccounts = [],
    selectedUser,
    onUserSelection,
    onExitToChild,
    user,
    switchingAccountId = null,
    isLoggingOut = false,
    startLogout,
    openSupportChat,
}) => {
    const impersonating = !!user?.impersonation
    // Le mot et le fond de la barre d'état suivent le thème : sur la nuit, un contenu « dark »
    // laisserait l'heure et les icônes du système en marine sur #152452.
    const statusBar = useParentStatusBar()

    return (
        <>
            <StatusBar
                style={statusBar.style}
                backgroundColor={statusBar.backgroundColor}
                translucent={false}
            />
            <ParentShellHeader
                familyAccounts={familyAccounts}
                selectedChildId={selectedUser?.userId}
                switchingChildId={switchingAccountId}
                onSelectChildId={(id) => {
                    const account = familyAccounts.find(
                        (candidate) => candidate?.userId === id
                    )
                    if (account) onUserSelection?.(account)
                }}
                onExitToChildId={(id) => {
                    const account = familyAccounts.find(
                        (candidate) => candidate?.userId === id
                    )
                    if (account) onExitToChild?.(account)
                }}
                profileDisabled={impersonating}
                // « Se déconnecter » : la déconnexion de la coquille, comme « Retour à la
                // sélection de compte » (`ParentHomeScreen`) — elle ramène sur « Qui
                // utilise Masteur ? ».
                onSwitchAccount={startLogout}
                switchingAccount={!!isLoggingOut}
                // Le bouton d'aide du header : la messagerie du support.
                onContactSupport={openSupportChat}
            />
        </>
    )
}
